<button mat-icon-button id="lockBtn" [disabled]="isAdmin" (click)="encryptDecrypt(true); changeIcon()">
  <i class="ri-lock-line" id="iconBtn"> </i>
</button>
